import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'

import { useSubmitOnboardingCompletedMutation } from '@twisto/api-graphql'
import { useAppConfig } from '@twisto/base'
import { FlowFormSubmitInfoView } from '@twisto/flow-views/components'
import { BigTickIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

export const OnboardingCompletedStep = () => {
  const { sessionId } = useFlow<'OnboardingCompletedStep'>()
  const [submitOnboardingCompleted] = useSubmitOnboardingCompletedMutation()
  const { brand } = useAppConfig()
  const handleSubmit = () =>
    submitOnboardingCompleted({
      variables: {
        auth: {
          sessionId,
        },
      },
    })

  const brandName = {
    /*i18n*/
    twisto: i18n._('flow.onboardingCompletedStep.brand.twisto'),
  }[brand]

  return (
    <FlowFormSubmitInfoView
      buttonText={<Trans id="flow.onboardingCompletedStep.button" />}
      icon={<BigTickIcon color="primary" height="100%" width="100%" />}
      subtitle={
        <Trans
          id="flow.onboardingCompletedStep.subtitle"
          values={{ brandName }}
        />
      }
      title={<Trans id="flow.onboardingCompletedStep.title" />}
      onSubmit={handleSubmit}
    />
  )
}
